import React, { Component } from "react";
import { Form, Input, Button, Alert } from "antd";
import { ReactComponent as Logo } from "../../svgs/logo.svg";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router";
import { withTranslation } from "react-i18next";
import helper from "../../utils/helper";
import "./style.scss";

/**
 * Component for showing reset password page.
 *
 * @component
 */
@inject("rootStore")
@observer
class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDirty: false,
    };
  }
  /**
   * componentDidMount
   * check whenever logined user enter the forgot page -redirect to home page
   * clear all error list
   */
  componentDidMount = () => {
    const { t } = this.props;
    document.title = t("reset_pass.page-title");
  };

  /**
   * handleSubmit
   * validation input then send back to store
   *
   */
  handleSubmit = (e) => {
    e.preventDefault();
    const {
      location,
      rootStore: {
        authStore: { finishResetPassword },
      },
    } = this.props;
    const resetKey = helper.getQueryString(location.search, "key");
    this.props.form.validateFields((err, values) => {
      if (!err) {
        finishResetPassword({
          reset_key: resetKey,
          new_password: values.password,
        });
      }
    });
  };

  /**
   * handleConfirmBlur
   * check whenever confirm pasword typing - check match validation rule or not
   */
  handleConfirmBlur = (e) => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  /**
   * compareToFirstPassword
   * check 2 password match consistent rule or not
   */
  compareToFirstPassword = (rule, value, callback) => {
    const { form, t } = this.props;
    if (value && value !== form.getFieldValue("password")) {
      callback(t("reset_pass.pass_inconsistent"));
    } else {
      callback();
    }
  };
  /**
   * validateToNextPassword
   * check whenever pasword typing - check match validation rule or not
   */
  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(["confirm"], { force: true });
    }
    callback();
  };

  /**
   * render
   *
   * @return  {Component}
   */
  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      rootStore: {
        authStore: { loading, errorList, clearErrorList },
      },
      t,
    } = this.props;
    return (
      <div className="wrap-change-password">
        <div className="wrap-error-comp">
          {errorList && (
            <Alert
              message={errorList.message}
              type="error"
              closable
              showIcon
              onClose={clearErrorList}
              className="spm-error-comp"
            />
          )}
        </div>
        <div className="wrap-login-comp">
          <Form
            onSubmit={this.handleSubmit}
            className="passwordreset-form"
            autoComplete="off"
          >
            <div className="logo-login">
              <Logo className="logo-img"> </Logo>
            </div>
            <div className="title-login">{t("reset_pass.title")}</div>
            <Form.Item label={t("reset_pass.password")} hasFeedback>
              {getFieldDecorator("password", {
                rules: [
                  {
                    required: true,
                    message: t("reset_pass.requried"),
                  },
                  {
                    validator: this.validateToNextPassword,
                  },
                ],
              })(<Input.Password autoComplete="off" maxLength={128} />)}
            </Form.Item>
            <Form.Item label={t("reset_pass.confrim_password")} hasFeedback>
              {getFieldDecorator("confirm", {
                rules: [
                  {
                    required: true,
                    message: t("reset_pass.confirm_requried"),
                  },
                  {
                    validator: this.compareToFirstPassword,
                  },
                ],
              })(
                <Input.Password
                  autoComplete="off"
                  maxLength={128}
                  onBlur={this.handleConfirmBlur}
                />
              )}
            </Form.Item>
            <Form.Item>
              <div className="password-rule">{t("common.password_rule")}</div>
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="reset-form-button"
                loading={loading}
              >
                {t("reset_pass.change")}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  }
}

const ResetPasswordForm = Form.create({ name: "reset_password_form" })(
  ResetPassword
);

export default withRouter(withTranslation()(ResetPasswordForm));
